import React, { useEffect, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { BiPlus } from "react-icons/bi";
import { Link } from "react-router-dom";
import * as L from "leaflet";
import axios from "axios";
import { useSelector } from "react-redux";
import { Spin } from "antd";
import DataTable from "react-data-table-component";
import { FiEye } from "react-icons/fi";



const DashboardTwo = () => {
  const userDetails = useSelector((state) => state.user.userDetails);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [siteLocations, setSiteLocations] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [markerLoading, setMarkerLoading] = useState(false)
  const [markerData, setMarkerData] = useState({
    count: 0,
    activeSensors: 0,
    inactiveSensors: 0,
  })

  const getSiteLocations = async () => {
    try {
      setIsLoading(true);
      if (userDetails.role === "superAdmin") {
        const response = await axios.get(`/site-location`, { withCredentials: true });
        if (response) {
          setIsLoading(false);
          setSiteLocations(response.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)));
        }
      }
      if (userDetails.role === "admin") {
        const response = await axios.get(
          `/site-location/admin-sites/` + userDetails._id,
          { withCredentials: true }
        );
        if (response) {
          setIsLoading(false);
          setSiteLocations(response.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)));
        }
      }
      if (userDetails.role === "installer") {
        const response = await axios.get(
          `/site-location/installer-sites/` + userDetails._id,
          { withCredentials: true }
        );
        if (response) {
          setIsLoading(false);
          setSiteLocations(response.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)));
        }
      }
    } catch (error) { }
  };

  const getSensorDetails = async (id) => {
    try {
      setMarkerLoading(true)
      const response = await axios.get(`/device/getSensorDetails/${id}`, { withCredentials: true })
      console.log(response)
      if (response.status === 200) {
        setMarkerData(response.data)
      }
      setMarkerLoading(false)
    } catch (error) {
      console.log(error)
    }
  }

  const handleMarkerClick = id => {
    getSensorDetails(id)
  }

  const columns = [
    {
      name: "No.",
      selector: (row, ind) => ind + 1,
      width: "60px",
    },
    {
      name: "Sensor Name",
      cell: (row) => (
        <p className="m-0">{row?.name || "--"}</p>
      ),
    },
    {
      name: "ApiKey",
      cell: (row) => row?.apiKey,
    },
    {
      name: "Site Name",
      cell: (row) => (
        <p className="m-0">{row?.site?.name || "--"}</p>
      ),
    },
    {
      name: "Status",
      cell: (row) => (
        <div>
          {row.isActive ? (
            <span className="badge text-bg-success">Online</span>
          ) : (
            <span className="badge text-bg-danger">Offline</span>
          )}
        </div>
      ),
      center: true,
      // width: '100px',
    },
    {
      name: "Action",
      width: "220px",
      center: true,
      cell: (row) => (
        <div>
          <Link title="View Sensor" to={`/devices/details/${row._id}`} className="btn btn-success me-1">
            <FiEye />
          </Link>          
        </div>
      ),
    },
  ];


  useEffect(() => {
    document.title = "ISE Switchgear 2.0 - Dashboard"
    getSiteLocations()
  }, []);
  return (
    <div className="az-content-body">
      <h5 className="pb-2">Advance Search Filters</h5>
      <div className="row mb-3">
        <div className="col-md-4">
          <Form className="d-flex">
            <Form.Control
              type="search"
              placeholder="Search"
              className="me-2"
              aria-label="Search"
            />
          </Form>
        </div>
        {/* <div className="col-md-2">
          <select className="form-select">
            <option value="kuchai">Select Disctrict</option>
            <option value="kuchai">Disctrict1</option>
            <option value="kuchai">Disctrict2</option>
            <option value="kuchai">Disctrict3</option>
          </select>
        </div> */}
        <div className="col-md-4">
          <select className="form-select">
            <option value="kuchai">Select PPU</option>
            <option value="kuchai"> 1</option>
            <option value="kuchai"> 2</option>
            <option value="kuchai"> 3</option>
          </select>
        </div>
        {/* <div className="col-md-2">
          <select className="form-select">
            <option value="kuchai">Select Status</option>
            <option value="kuchai"> 1</option>
            <option value="kuchai"> 2</option>
            <option value="kuchai"> 3</option>
          </select>
        </div> */}
        <div className="col-md-2">
          <Button variant="success">Search</Button>
        </div>
        {/* <div className="col-md-2">
          <Link to='/add-site-location'><Button variant="primary">
            <BiPlus></BiPlus> Add Substation
          </Button></Link>
        </div> */}
      </div>
      <div className="row row-sm mg-b-15 mg-sm-b-20">
        <div className="col-lg-12 py-5">
          <MapContainer
            center={[3.0534, 101.6571]}
            zoom={13}
            scrollWheelZoom={false}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {
              siteLocations.length > 0 && siteLocations.map(site => {
                const latitude = site.latitude
                const longitude = site.longitude
                if (latitude && longitude) {
                  return (
                    <Marker key={site._id} position={[latitude, longitude]} eventHandlers={{ click: () => handleMarkerClick(site._id) }}>
                      {console.log({ site, markerLoading })}
                      <Popup>
                        <Spin spinning={markerLoading}>
                          <h6 className='fw-bold'> {site.name} </h6>
                          <Table className='table-borderless fw-bold'>
                            <tr className="table-primary">
                              <td className='py-1'>Total Sensors</td>
                              <td className='py-1'> : </td>
                              <td className='py-1'>{markerData.count}</td>
                            </tr>
                            <tr className='table-success'>
                              <td className='py-1'>Online Sensors</td>
                              <td className='py-1'> : </td>
                              <td className='py-1 text-success'>{markerData.activeSensors}</td>
                            </tr>
                            <tr className='table-danger'>
                              <td className='py-1'>Offline Sensors</td>
                              <td className='py-1'> : </td>
                              <td className='py-1 text-danger'>{markerData.inactiveSensors}</td>
                            </tr>
                          </Table>
                          <div className="d-flex justify-content-end">
                            <Link to={`site-locations/details/${site._id}`}>
                              <Button variant='success'>
                                View
                              </Button>
                            </Link>
                          </div>
                        </Spin>
                      </Popup>
                    </Marker>
                  )
                } else {
                  return ''
                }
              })
            }
          </MapContainer>
        </div>
      </div>


      <div className="row row-sm mg-b-15 mg-sm-b-20">
        <div className="col-lg-12">
          <div className="card card-dashboard-six">
            <div className="card-header">
              <div>
                <label className="az-content-label">SEARCH RESULTS</label>
              </div>
            </div>
            {/* <Spin spinning={isLoading}>
              <DataTable
                columns={columns}
                data={siteLocations}
                pagination
                paginationServer
                noDataComponent={isLoading ? "Loading" : "No record found."}
                className="mt-3"
                paginationTotalRows={total}
                paginationPerPage={limit}
                onChangePage={(data) => {
                  setPage(data);
                }}
                onChangeRowsPerPage={(data) => {
                  setLimit(data);
                  setPage(1);
                }}
                paginationRowsPerPageOptions={[10, 20, 50]}
              />
            </Spin> */}
            <Table striped className="text-center">
              <thead>
                <tr>
                  <th className="fw-bold text-black">No</th>
                  <th className="fw-bold text-black">Code</th>
                  <th className="fw-bold text-black">Description</th>
                  <th className="fw-bold text-black">Location</th>
                  <th className="fw-bold text-black">State</th>
                  <th className="fw-bold text-black">Status</th>
                  <th className="fw-bold text-black">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>PPU1234</td>
                  <td>33/2KV</td>
                  <td>Kuchai-lama</td>
                  <td>Kuala Lumpur</td>
                  <td>Active</td>
                  <Link to="/device-details"><Button variant="success" size="sm">Details</Button></Link>
                </tr>
                <tr>
                  <td>2</td>
                  <td>PPU1234</td>
                  <td>33/2KV</td>
                  <td>Kuchai-lama</td>
                  <td>Kuala Lumpur</td>
                  <td>Active</td>
                  <Link to="/device-details"><Button variant="success" size="sm">Details</Button></Link>
                </tr>
                <tr>
                  <td>3</td>
                  <td>PPU1234</td>
                  <td>33/2KV</td>
                  <td>Kuchai-lama</td>
                  <td>Kuala Lumpur</td>
                  <td>Active</td>
                  <Link to="/device-details"><Button variant="success" size="sm">Details</Button></Link>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardTwo;
